import {DayOfWeekStaticLandingPageVo} from '../../common/shared/api/karina/vo/page/DayOfWeekStaticLandingPageVo.interface';
import {
  StaticLandingDayOfWeekParamInput,
  StaticLandingDayOfWeekSectionParam,
} from '../generated/types';
import {createSortOption} from './SortOption';

export function createStaticLandingDayOfWeekSectionParam(
  landingVo: DayOfWeekStaticLandingPageVo,
  input: StaticLandingDayOfWeekParamInput
): StaticLandingDayOfWeekSectionParam {
  return {
    categoryUid: input.categoryUid,
    businessModel: landingVo.selected_bm_opt
      ? createSortOption({filterOptionVo: landingVo.selected_bm_opt})
      : undefined,
    subcategory: landingVo.selected_subcat_opt
      ? createSortOption({filterOptionVo: landingVo.selected_subcat_opt})
      : undefined,
    dayTab: landingVo.selected_tab_opt
      ? createSortOption({filterOptionVo: landingVo.selected_tab_opt})
      : undefined,
    page: input.page,
    size: input.size,
    screenUid: input.screenUid,
  };
}
